import { Injectable } from '@angular/core';
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';

import { MatSnackBar } from '@angular/material/snack-bar';
import { Route, Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private _snackBar: MatSnackBar, private auth: AuthService,
        private _router:Router) {}

    get accessToken(): string {
        return localStorage.getItem('token') ?? '';
    }

    /**
     * Intercept
     *
     * @param req
     * @param next
     */
    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        // Clone the request object
        let newReq = req.clone();

        // Request
        //
        // If the access token didn't expire, add the Authorization header.
        // We won't add the Authorization header if the access token expired.
        // This will force the server to return a "401 Unauthorized" response
        // for the protected API routes which our response interceptor will
        // catch and delete the access token from the local storage while logging
        // the user out from the app.
        // if (! req.headers.get('authorization')  )
        // if (this.accessToken && !req.headers.get('Authorization') && !AuthUtils.isTokenExpired(this.accessToken)) {
        //TODO: Refactor this
        if (this.accessToken && !req.headers.get('Authorization')) {
            //console.log( "***********");

            //console.log(this.accessToken);
            newReq = req.clone({
                // headers: req.headers.set('Authorization', 'Bearer ' + this.accessToken),
                setHeaders: {
                    Authorization: 'Bearer ' + this.accessToken,
                    'ngrok-skip-browser-warning': 'any-value',
                },

                // .set('ngrok-skip-browser-warning', 'any-value')
            });

            // request = request.clone({
            //     setHeaders: { Authorization: `Bearer ${token}` },
            //   });
        }

        // Response
        return next.handle(newReq).pipe(
            catchError((error) => {
                // Catch "401 Unauthorized" responses
                if (
                    !req.url.includes('/Auth/login') &&
                    error instanceof HttpErrorResponse &&
                    error.status === 401
                ) {
                    // Sign out
                    this._snackBar.open(error.error?.message ?? 'Error', error.error?.status ?? 'Error', { duration: 5000 });

                    this.auth.signOut()
                    this._router.navigate(['/sign-in'])
                    // if(error.error.message.includes('dactivated')) {
                    //     this.auth.signOut()
                    //     this._router.navigate(['/sign-in'])
                    // }
                    // Reload the app
                    // location.reload();ß
                }
                if(error.status === 440) {
                    this.auth.signOut()
                    this._snackBar.open(error.error?.message ?? 'Error', error.error?.status ?? 'Error', { duration: 5000 });
                    this._router.navigate(['/sign-in'])
                }
                if (error instanceof HttpErrorResponse) {
                    // console.log(error.error);

                    let err = error.error;

                    // this._snackBar.open(
                    //     err?.message ?? 'Error',
                    //     err?.status ?? 'Error',
                    //     { duration: 2000 }
                    // );
                }

                return throwError(() => error);
            })
        );
    }
}
